<div class="auth-wrapper">
  @if (configLoading || customPageChecking) {
    <div class="auth-loading" role="status" aria-live="polite">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'login.headline' | transloco }}</h1>
      <p class="supporting">{{ 'login.supporting' | transloco }}</p>

      <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
        <input type="hidden" formControlName="clientId" [value]="clientId"/>

        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>{{ 'login.form.emailLabel' | transloco }}</mat-label>
          <input matInput formControlName="email" maxlength="254"/>
        </mat-form-field>

        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>{{ 'common.form.passwordLabel' | transloco }}</mat-label>
          <input matInput type="password" formControlName="password"/>
        </mat-form-field>

        @if (resetSuccess) {
          <p class="success" role="status">{{ 'login.resetSuccess' | transloco }}</p>
        }
        @if (error) {
          <p class="error" role="alert">{{ error }}</p>
        }
        @if (emailNotVerified) {
          @if (resendSent) {
            <p class="success" role="status">{{ 'login.resendSent' | transloco }}</p>
          } @else {
            <button mat-stroked-button type="button" (click)="resendVerification()" [disabled]="resendInProgress">
              {{ 'login.resendButton' | transloco }}
            </button>
          }
        }

        <button mat-flat-button color="primary" type="submit"
                [attr.aria-busy]="captchaSolving ? 'true' : null"
                [disabled]="loginForm.invalid || loginForm.pristine || submitting">{{ (submitting ? 'login.submitting' : 'login.submit') | transloco }}</button>
        <p class="visually-hidden" role="status" aria-live="polite">{{ captchaSolving ? ('common.captcha.verifying' | transloco) : '' }}</p>

        <div class="forgot-password-link">
          <a [routerLink]="['/forgot-password']" queryParamsHandling="preserve">{{ 'login.forgotPasswordLink' | transloco }}</a>
        </div>
        @if (signupEnabled) {
          <div class="signup-link">
            {{ 'login.noAccount' | transloco }} <a [routerLink]="['/signup']" queryParamsHandling="preserve">{{ 'login.createAccountLink' | transloco }}</a>
          </div>
        }
      </form>
    </mat-card-content>
  </mat-card>
  }
</div>
